import { VideoConverterPresetProps } from "../../interfaces/core";

export const defaultPresets: VideoConverterPresetProps[] = [
  {
    name: "LOVE",
    type: "preset",
    preset: {
      audio: {
        enabled: false,
      },
      display: {
        dpi: 36,
        background: {
          h: 357,
          s: 55,
          l: 61,
        },
      },
      pixel: {
        type: "character",
        options: {
          displayMode: "random",
          character: "l,o,v,e",
          characterColor: {
            h: 324,
            s: 31,
            l: 91,
          },
        },
      },
    },
  },
  {
    name: "Emoji • Faces",
    type: "preset",
    preset: {
      audio: {
        enabled: false,
      },
      display: {
        dpi: 144,
        background: {
          h: 236,
          s: 100,
          l: 100,
        },
      },
      pixel: {
        type: "emoji",
        options: {
          source: [
            "😀",
            "😃",
            "😄",
            "😁",
            "😆",
            "😅",
            "😂",
            "🤣",
            "🥲",
            "😊",
            "😇",
            "🙂",
            "🙃",
            "😉",
            "😌",
            "😍",
            "🥰",
            "😘",
            "😗",
            "😙",
            "😚",
            "😋",
            "😛",
            "😝",
            "😜",
            "🤪",
            "🤨",
            "🧐",
            "🤓",
            "😎",
            "🥸",
            "🤩",
            "🥳",
            "😏",
            "😒",
            "😞",
            "😔",
            "😟",
            "😕",
            "🙁",
            "😣",
            "😖",
            "😫",
            "😩",
            "🥺",
            "😢",
            "😭",
            "😤",
            "😠",
            "🤯",
            "😥",
            "😓",
            "🤗",
            "🤔",
            "🤭",
            "🤫",
            "🤥",
            "😶",
            "😐",
            "😑",
            "😬",
            "🙄",
            "😯",
            "😦",
            "😧",
            "😮",
            "😲",
            "🥱",
            "😴",
            "🤤",
            "😪",
            "😵",
            "🤐",
            "🥴",
            "🤧",
            "😷",
            "🤒",
            "🤕",
            "🤑",
            "🤠",
            "😺",
            "😸",
            "😹",
            "😻",
            "😼",
            "😽",
            "🙀",
            "😿",
            "😾",
          ],
          displayMode: "fixed",
        },
      },
    },
  },
  {
    name: "Circle • Purple",
    type: "preset",
    preset: {
      audio: {
        enabled: false,
      },
      display: {
        dpi: 72,
        background: {
          h: 255,
          s: 28,
          l: 49,
        },
      },
      pixel: {
        type: "circle",
        options: {
          forgroundColor: {
            h: 297,
            s: 52,
            l: 88,
          },
        },
      },
    },
  },
  {
    name: "Emoji • Ekraine vs. Russia",
    type: "preset",
    preset: {
      audio: {
        enabled: true,
      },
      display: {
        dpi: 96,
        background: {
          h: 222,
          s: 40,
          l: 92,
        },
      },
      pixel: {
        type: "character",
        options: {
          displayMode: "wave",
          character: "🇺🇦,🇷🇺",
          characterColor: {
            h: 324,
            s: 31,
            l: 91,
          },
        },
      },
    },
  },
  {
    name: "Matrix",
    type: "preset",
    preset: {
      audio: {
        enabled: false,
      },
      display: {
        dpi: 60,
        background: {
          h: 150,
          s: 13,
          l: 8,
        },
      },
      pixel: {
        type: "character",
        options: {
          displayMode: "random",
          character: "0,1",
          characterColor: {
            h: 128,
            s: 91,
            l: 57,
          },
        },
      },
    },
  },
];
